import { render } from "./PerformanceRatioSolarPanelForm.vue?vue&type=template&id=88173900"
import script from "./PerformanceRatioSolarPanelForm.vue?vue&type=script&lang=js"
export * from "./PerformanceRatioSolarPanelForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__